import { useEffect } from "react";
import queryString from "query-string";
import { config } from "node-config-ts";
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

export const useDataDog = () => {
    const initializeDataDogLogsAndRum = (samplingRate: number) => {
        datadogLogs.init({
            clientToken: 'pub3796b93595285ee4180647b379c15bb0',
            site: 'datadoghq.com',
            version: process.env.REACT_APP_VERSION,
            env: config.APPLICATION_ENVIRONMENT,
            forwardErrorsToLogs: true,
            sessionSampleRate: 100,
            service: 'axnui-v4'
        });

        datadogRum.init({
            applicationId: '1423ad45-0d45-4cf3-b531-d32e5c625dc6',
            clientToken: 'pub3796b93595285ee4180647b379c15bb0',
            site: 'datadoghq.com',
            version: process.env.REACT_APP_VERSION,
            env: config.APPLICATION_ENVIRONMENT,
            service: 'axnui-v4',
            sessionSampleRate: 10,
            sessionReplaySampleRate: samplingRate,
            startSessionReplayRecordingManually: true,
            trackUserInteractions: true,
            allowedTracingUrls: [
                /https:\/\/.*\.iddataweb\.com/,
                /https:\/\/.*\.iddataweb\.io/
            ]
        });
    };

    const beginDataDogSession = () => {
        const query = location.search || window.location.search;
        const queryParameters = queryString.parse(query, { decode: true }) as { [key: string]: string };

        let samplingRate = 0;
        if (queryParameters.samplingRate && !isNaN(parseInt(queryParameters.samplingRate))) {
            samplingRate = parseInt(queryParameters.samplingRate);
        }

        initializeDataDogLogsAndRum(samplingRate);

        datadogLogs.setGlobalContextProperty('asi', queryParameters.asi);
        datadogRum.setGlobalContextProperty('asi', queryParameters.asi);
        datadogRum.setUser({
            id: queryParameters.asi,
            asi: queryParameters.asi
        });

        datadogRum.startSessionReplayRecording();
    };

    useEffect(() => {
        beginDataDogSession();
    }, []);
};